module.exports = __webpack_public_path__ + "assets/img/pdf-icon.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/pdf-icon.png
// module id = 1943
// module chunks = 0